export default class TranslationExportRequestModel {
    componentId:number
    contextId:number
}
